import React, { useState, useRef } from 'react';
import './MessageInput.css';

export default function MessageInput({ onSend, onAttach, disabled }) {
    const [text, setText] = useState('');
    const fileRef = useRef(null);

    const handleSend = () => {
        const trimmed = text.trim();
        if (!trimmed) return;
        onSend(trimmed);
        setText('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) onAttach(file);
        e.target.value = '';
    };

    return (
        <div className="message-input">
            <button
                className="message-input-attach"
                onClick={() => fileRef.current.click()}
                disabled={disabled}
                title="Прикрепить файл"
            >
                📎
            </button>
            <input
                type="file"
                ref={fileRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept="image/*,.pdf,.doc,.docx"
            />
            <textarea
                className="message-input-field"
                value={text}
                onChange={e => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Написать сообщение..."
                disabled={disabled}
                rows={1}
            />
            <button
                className="message-input-send"
                onClick={handleSend}
                disabled={disabled || !text.trim()}
            >
                ➤
            </button>
        </div>
    );
}
